<div kalDialogContent>

    <p *ngIf="data.message" class="gup-U-margin-bottom--small">{{ data.message }}</p>

    <kal-table
        [columns]="columns"
        [dataSource]="letteredBookEntriesList"
        class="gup-C-detailCommande__table no-action">

        <tr *kalHeaderRowDef kal-header-row></tr>

        <ng-container [kalColumn]="columns[9].code">
            <td *kalBodyCell="let row">
                {{row.Debit |currency:'EUR'}}
            </td>
        </ng-container>

        <ng-container [kalColumn]="columns[10].code">
            <td *kalBodyCell="let row">
                {{row.Credit |currency:'EUR'}}
            </td>
        </ng-container>

    </kal-table>

</div>

<div kalDialogFooter>

    <div class="gup-C-validationArea gup-O-list">

        <div class="gup-O-list__item">

            <kal-button id="order_line_detail_dialog_submit"
                        kalTheme="primary"
                        (click)="confirm()">
                Supprimer
            </kal-button>

        </div>

        <div class="gup-O-list__item">

            <kal-button id="lettered_book_entries_dialog_close"
                        kalTheme="secondary"
                        (click)="cancel()">
                Annuler
            </kal-button>

        </div>

    </div>

</div>
